import { agentDisplayLabel, agentRealName } from './agentDisplay';

// Searching a list of people by what is typed: "ani blo", "royal flush", "team lead". Every word typed has to be found somewhere in
// the person (name, nickname, team, position); accents and capitals do not matter.

const norm = (v) => String(v == null ? '' : v)
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .trim()
  .toLowerCase();

/** The words of what was typed, normalised. */
export const queryWords = (query) => norm(query).split(/\s+/).filter(Boolean);

const fieldsOf = (person) => [agentRealName(person), person.real_name, person.team, person.role_label, person.role].map(norm).filter(Boolean);

/**
 * The people matching `query`, best first: those whose name starts with the first word, then those with a name, team or position
 * word that starts with it, then the rest; each group in name order. An empty query is everybody in name order.
 * Never changes the list it is given.
 */
export function searchPeople(people, query) {
  const words = queryWords(query);
  const rows = [];
  (people || []).forEach((person) => {
    const fields = fieldsOf(person);
    if (!words.every((w) => fields.some((f) => f.includes(w)))) return;
    let rank = 0;
    if (words.length) {
      if (norm(agentDisplayLabel(person)).startsWith(words[0])) rank = 0;
      else if (fields.some((f) => f.split(/\s+/).some((part) => part.startsWith(words[0])))) rank = 1;
      else rank = 2;
    }
    rows.push({ person, rank });
  });
  return rows
    .sort((a, b) => a.rank - b.rank || agentRealName(a.person).localeCompare(agentRealName(b.person), undefined, { sensitivity: 'base' }))
    .map((r) => r.person);
}
